import { Currency, formatDate, formatMoney, formatNumber } from '@nemuru-eng/js-api-client';
import { ReactNode } from 'react';

import { EditAutoPaymentMethodSummaryRowData } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/components/EditAutoPaymentMethodSummarySection';
import { normalizeSpanishLicensePlate } from '@/utils/zodValidation/validateSpanishLicensePlate';

export const createEditVehicleLiveSummaryFormatters = () => {
  const emptyValue = '-';

  const formatTextField = (value: string | null | undefined): string => value?.trim() || emptyValue;

  const formatPrice = (price: string | undefined, currency: Currency): string => {
    const parsedPrice = Number.parseFloat(price ?? '');

    if (Number.isNaN(parsedPrice)) {
      return emptyValue;
    }

    return formatMoney({ value: parsedPrice, currency }, 2);
  };

  const formatMoneyAmount = (amount: number | null | undefined, currency: Currency): string => {
    if (amount === null || amount === undefined) {
      return emptyValue;
    }

    return formatMoney({ value: amount, currency }, 2);
  };

  const formatOdometer = (odometer: string | null | undefined): string => {
    if (!odometer) {
      return emptyValue;
    }

    const parsedValue = Number.parseInt(odometer, 10);

    if (Number.isNaN(parsedValue)) {
      return emptyValue;
    }

    return `${formatNumber(parsedValue, 0)}`;
  };

  const formatPlateNumber = (plateNumber: string | undefined): string => {
    if (!plateNumber) {
      return emptyValue;
    }

    return normalizeSpanishLicensePlate(plateNumber);
  };

  const formatRegistrationDate = (registrationDate: Date | null | undefined): string => {
    if (!registrationDate || isNaN(registrationDate.getTime())) {
      return emptyValue;
    }

    return formatDate(registrationDate);
  };

  const formatTerm = (term: number | null): string => {
    if (term === null || term === undefined) {
      return emptyValue;
    }

    return String(term);
  };
  return {
    formatTextField,
    formatPrice,
    formatMoneyAmount,
    formatOdometer,
    formatPlateNumber,
    formatRegistrationDate,
    formatTerm,
  };
};

export type EditVehicleLiveSummaryFormatters = ReturnType<typeof createEditVehicleLiveSummaryFormatters>;

export const buildLiveSummaryRow = (
  labelTextId: string,
  originalValue: string,
  newValue: string,
  endAdornment?: string | ReactNode,
): EditAutoPaymentMethodSummaryRowData => ({
  labelTextId,
  originalValue,
  newValue,
  hasChanged: originalValue !== newValue,
  endAdornment,
});

export const parseVehicleAmount = (value: string | undefined): number | null => {
  const parsedValue = Number.parseFloat(value ?? '');

  return Number.isNaN(parsedValue) ? null : parsedValue;
};
